import React, { Component } from 'react';
import moment from 'moment';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Button from '@material-ui/core/Button';
import GoogleReview from './GoogleReview';

const styles = {
	card: {
		minWidth: 275
	},
	bullet: {
		display: 'inline-block',
		margin: '0 2px',
		transform: 'scale(0.8)'
	},
	title: {
		marginBottom: 16,
		fontSize: 14
	},
	pos: {
		marginBottom: 12
	}
};

class CustomerReviews extends Component {
	state = { filter: 'ALL', anchorEl: null };

	getTimeAgo = time => moment(time).fromNow();

	setFilter = () => {};

	handleClick = event => {
		this.setState({ anchorEl: event.currentTarget });
	};

	handleClose = starRating => {
		this.setState({ anchorEl: null, filter: starRating });
	};

	renderGoogleReviews = () => {
		if (!this.props.reviews) {
			return <div>No Reviews Found. </div>;
		}
		console.log(this.props.reviews);
		return this.props.reviews
			.filter(review => {
				if (this.state.filter !== 'ALL') {
					return (
						review.starRating === this.state.filter ||
						review.rating === this.state.filter
					);
				}
				return true;
			})
			.map(review => (
				<GoogleReview
					isCorporate={this.props._business}
					id={review.reviewId}
					key={review.reviewId || Date.now()}
					author={review.author_name || review.reviewer.displayName}
					rating={review.rating || review.starRating}
					time={
						review.relative_time_description ||
						this.getTimeAgo(review.createTime)
					}
					text={review.text || review.comment}
					response={review.reviewReply || false}
					google
				/>
			));
	};

	render() {
		const { classes } = this.props;
		const { anchorEl } = this.state;

		return (
			<div>
				<Card
					zdepth={1}
					style={{
						maxHeight: '672px',
						overflow: 'auto',
						marginTop: '8px',
						marginBottom: '8px'
					}}
				>
					<CardContent>
						<div
							style={{
								maxHeight: '100%'
							}}
						>
							<div
								style={{
									display: 'flex',
									flexDirection: 'row',
									justifyContent: 'space-between'
								}}
							>
								<Typography
									className={classes.title}
									variant="headline"
									color="textSecondary"
								>
									Google Reviews
								</Typography>
								<Button
									aria-owns={anchorEl ? 'simple-menu' : null}
									variant="contained"
									disableElevation
									style={{
										paddingTop: 8,
										paddingBottom: 8,
										paddingLeft: 18,
										paddingRight: 18,
										backgroundColor: '#c655d6',
										color: '#fff',
										borderRadius: 10,
										textTransform: 'uppercase',
										fontWeight: 700,
										letterSpacing: '0.06em',
									}}
									aria-haspopup="true"
									onClick={this.handleClick}
								>
									Filter Reviews
								</Button>
								<Menu
									id="simple-menu"
									anchorEl={anchorEl}
									open={Boolean(anchorEl)}
									onClose={this.handleClose}
								>
									<MenuItem
										onClick={() => this.handleClose('ALL')}
									>
										See All
									</MenuItem>
									<MenuItem
										onClick={() => this.handleClose('FIVE')}
									>
										Five Star
									</MenuItem>
									<MenuItem
										onClick={() => this.handleClose('FOUR')}
									>
										Four Star
									</MenuItem>
									<MenuItem
										onClick={() =>
											this.handleClose('THREE')
										}
									>
										Three Star
									</MenuItem>
									<MenuItem
										onClick={() => this.handleClose('TWO')}
									>
										Two Star
									</MenuItem>
									<MenuItem
										onClick={() => this.handleClose('ONE')}
									>
										One Star
									</MenuItem>
								</Menu>
							</div>
							{this.renderGoogleReviews()}
						</div>
					</CardContent>
				</Card>
			</div>
		);
	}
}

export default withStyles(styles)(CustomerReviews);



// WEBPACK FOOTER //
// ./src/components/review/ReviewTable/Modal/CustomerReviews.js